module.exports = __webpack_public_path__ + "img/13.adf355a4.svg";